import { useCallback, useEffect, useState } from 'react'

import { Embla } from '@mantine/carousel'

export type SlideInfoProps = {
  canScrollNext: boolean
  canScrollPrev: boolean
  slidesInView: number[]
  currentSlide: number
  totalSlide: number
}

export function useSlideInfo(embla: Embla | null, totalSlide: number) {
  const [slideInfo, setSlideInfo] = useState<SlideInfoProps>({
    canScrollNext: true,
    canScrollPrev: false,
    slidesInView: [0],
    currentSlide: 0,
    totalSlide,
  })

  const handleScroll = useCallback(() => {
    if (!embla) return
    setSlideInfo({
      canScrollNext: embla.canScrollNext(),
      canScrollPrev: embla.canScrollPrev(),
      slidesInView: embla.slidesInView(),
      currentSlide: embla.selectedScrollSnap(),
      totalSlide,
    })
  }, [embla])

  useEffect(() => {
    if (embla) {
      embla.on('scroll', handleScroll)
      handleScroll()
    }
  }, [embla])

  return { slideInfo }
}
